import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    Typography
} from '@material-ui/core';
import { KeyboardArrowDown } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    expansionPanel: {
        marginBottom: theme.spacing(2),
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        borderRadius: '8px',
        '&:before': {
            display: 'none',
        },
    },
    expansionPanelSummary: {
        backgroundColor: '#f8f9fa',
        borderRadius: '8px 8px 0 0',
        '&.Mui-expanded': {
            backgroundColor: '#3273dc',
            color: '#fff',
            '& .MuiExpansionPanelSummary-expandIcon': {
                color: '#fff',
            },
        },
    },
    expansionPanelTitle: {
        fontSize: '1.8rem',
        fontWeight: 600,
        '&.Mui-expanded': {
            color: '#fff',
        },
    },
    expandIcon: {
        color: '#4a4a4a',
        fontSize: '1.5rem',
    },
    expansionPanelDetails: {
        padding: theme.spacing(3),
        backgroundColor: '#fff',
        borderRadius: '0 0 8px 8px',
    },
}));

const HelpPanel = ({ title, children, show }) => {
    const classes = useStyles();
    const [expanded, setExpanded] = useState(show);

    const handleChange = (event, isExpanded) => {
        setExpanded(isExpanded);
    };

    return (
        <ExpansionPanel
            className={classes.expansionPanel}
            expanded={expanded}
            onChange={handleChange}
        >
            <ExpansionPanelSummary
                className={classes.expansionPanelSummary}
                expandIcon={<KeyboardArrowDown className={classes.expandIcon} />}
                aria-controls={`${title}-content`}
                id={`${title}-header`}
            >
                <Typography className={classes.expansionPanelTitle}>
                    {title}
                </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                {children}
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
};

export default HelpPanel;
